// NOTE: Dependencies: jQuery, jQuery Validate

(function ($) {
	$.fn.lmValidation = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			form: '#mediaForm',
			username: '#username',
			password: '#password',
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		// On load function
		methods.initContext = function($context) {
			methods.setCurrentSettings($context);

			$(settings.form).validate({
				onkeyup: false,
				onfocusin: function(element) {
					$(element).valid();
				},
				onfocusout: function(element) {
					$(element).valid();
				},
				rules: {},
				messages: {},
				errorElement: "div",
				errorPlacement: function(error, element) {
					error.appendTo("#formErrors");
				},
				errorClass : "error",
				highlight: function (element, errorClass, validClass) {
					$(element).addClass("error");
					$(element.form).find("label[for=" + element.id + "]").addClass("error");
				},
				unhighlight: function (element, errorClass, validClass) {
					$(element).removeClass("error");
					$(element.form).find("label[for=" + element.id + "]").removeClass("error");
				},
				debug: true,
				submitHandler: function(form) {  
					if ($(form).valid()) {
						form.submit(); 
					}
					return false;
				}
			});
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			var $this = $(this);

			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($this);
		});
	};
}(jQuery));